<template>
  <div class="grid grid-cols-1 gap-y-12 md:grid-cols-3 md:gap-x-2">
    <EnExperienceCard
      v-for="(experience, i) in experiences"
      :key="experience.id"
      theme="light"
      :aria-label="`experience card ${i}`"
      :data-testid="`experience-card-${i}`"
      :display-multiple-images="true"
      :display-number-of-images="SEARCH_EXPERIENCES_SEQUENCE_ID_THRESHOLD"
      :experience="experience"
      :on-experience-click="(slug: string) => onExperienceClick?.(slug, i + 1)"
      :orientation="orientation"
    />
  </div>
</template>

<script setup lang="ts">
import EnExperienceCard from '@/components/organisms/pages/en/experienceCard/EnExperienceCard.vue';
import { useIsSP } from '@/composables/ui/useIsSP';
import type { WabunkaExperienceListViewModel } from '@/models/wabunka/wabunkaExperience';
import { SEARCH_EXPERIENCES_SEQUENCE_ID_THRESHOLD } from '@/wabunka-src/constants/enExperiences';
interface Props {
  experiences: WabunkaExperienceListViewModel;
  /** カードクリック時のコールバック。position はページ内の表示順位（1 始まり） */
  onExperienceClick?: (experienceSlug: string, position: number) => void;
}

const isSP = useIsSP();
const orientation = computed(() => (isSP.value ? 'vertical' : 'horizontal'));

withDefaults(defineProps<Props>(), {});
</script>
